/* eslint-disable react/self-closing-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { currencyFormatDecimals, numberFormat } from 'constants/formats';
import { dayMonYea } from 'utils/formatDate';

import DocumentsColumn from 'modules/_shared/components/DocumentsColumn';
import transactionNames from 'modules/transactions/constants/transactionNames';
import { societyHasTitles } from 'utils/societyHasTitles';
import { getTransactionAmount } from 'modules/transactions/pages/OperationDetails/utils/getTransactionAmount';
import { getTransactionNominalValue } from 'modules/transactions/utils/getTransactionNominalValue';
import { getTransactionHoldingClass } from 'modules/transactions/utils/getTransactionHoldingClass';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import { getTransactionKey } from 'modules/partners/utils';
import { getTransactionDetailsUrl } from 'modules/transactions/utils/getTransactionDetailsUrl';
import { getTransactionSharesCount } from 'modules/transactions/utils/getTransactionSharesCount';
import DocumentsSpinner from 'modules/_shared/components/DocumentsColumn/components/DocumentsSpinner';
import { useGetTransactionTitle } from './hooks/useGetTransactionTitle';
import { showLoadedDocuments } from './utils/showLoadedDocuments';

const showDetails = JSON.parse(localStorage.getItem('showDetails'));

function PartnerTransactionsRow({
  index,
  transaction,
  sharesTitles,
  isLoadingSharesTitles,
  society,
  societySharesTitleDocument,
  documents,
  tag,
}) {
  const { t } = useTranslate();

  const holdingClasses = useSelector((state) => state.holdingClasses);
  const actualSociety = useSelector((state) => state?.society?.actualSociety);

  const [shares] = useState(getTransactionSharesCount(transaction));

  const holdingClass = getTransactionHoldingClass(holdingClasses, transaction);

  const transactionLink = getTransactionDetailsUrl(transaction, society?._id);

  const nominalValue = getTransactionNominalValue({
    holdingClass,
    transaction,
    society,
  });

  const amount =
    transaction?.amount ||
    getTransactionAmount({
      transaction,
      shares,
      nominalValue,
    });

  const tooltipId = `transaction-comments-${getTransactionKey(transaction)}`;

  const hasTilesEnabled = societyHasTitles(actualSociety);
  const { transactionTitle, titleWatermarkText } = useGetTransactionTitle({
    sharesTitles,
    transaction,
    society,
  }).data;

  return (
    <tr>
      <td className="d-none d-xl-table-cell text-right vertical-align-middle">
        <b>{index}</b>
      </td>

      <td className="vertical-align-middle">
        <Link to={transactionLink} className="text-primary">
          <em className="icon ni ni-link mr-1" />
          {t(
            transactionNames[transaction?.alias || transaction?.transactionType]
          )}
        </Link>
      </td>

      <td className="d-none d-xl-table-cell text-center vertical-align-middle">
        {dayMonYea(transaction?.date)}
      </td>

      <td className="tb-col-end vertical-align-middle">
        <NumberFormat
          value={+amount}
          displayType="text"
          {...currencyFormatDecimals}
        />
      </td>

      <td className="text-right vertical-align-middle">
        {shares ? (
          <NumberFormat
            value={shares}
            displayType="text"
            {...numberFormat}
            decimals={0}
          />
        ) : (
          '-'
        )}
      </td>

      {society?.hasShareTags && showDetails && (
        <td className="d-none d-xl-table-cell vertical-align-middle">
          {tag || '-'}
        </td>
      )}

      <td className="d-none d-xl-table-cell vertical-align-middle text-center">
        {holdingClasses.find(
          (holding) => holding['_id'] === transaction?.shareClass
        )?.name || '-'}
      </td>

      <td className="d-none d-xl-table-cell text-right vertical-align-middle">
        {transaction?.shareFrom ? (
          <NumberFormat
            value={transaction.shareFrom}
            displayType="text"
            {...numberFormat}
            decimals={0}
          />
        ) : (
          '-'
        )}
      </td>

      <td className="d-none d-xl-table-cell text-right vertical-align-middle">
        {transaction?.shareTo ? (
          <NumberFormat
            value={transaction.shareTo}
            displayType="text"
            {...numberFormat}
            decimals={0}
          />
        ) : (
          '-'
        )}
      </td>

      <td
        className="text-center p-0 w-20px mx-auto vertical-align-middle"
        style={{ width: '30px' }}
      >
        <IconTooltip id={tooltipId} tooltip={transaction?.comments || ''} />
      </td>

      <td
        className="text-center p-0 w-20px mx-auto vertical-align-middle"
        style={{ width: '30px' }}
      >
        {showLoadedDocuments({ documents, transaction })}
      </td>

      {isLoadingSharesTitles ? (
        <td className="d-none d-xl-table-cell vertical-align-middle text-center">
          <DocumentsSpinner />
        </td>
      ) : (
        <>
          {hasTilesEnabled &&
            (transactionTitle ? (
              <DocumentsColumn
                index={index}
                documentsCount={1}
                documents={
                  societySharesTitleDocument ? [societySharesTitleDocument] : []
                }
                hideOnMobile={false}
                sources={{
                  society: actualSociety?._id,
                  sharesTitle: transactionTitle?._id,
                }}
                templateWatermarkText={titleWatermarkText}
              />
            ) : (
              <td className="d-none d-md-table-cell vertical-align-middle text-center">
                <span>-</span>
              </td>
            ))}
        </>
      )}
    </tr>
  );
}

export default PartnerTransactionsRow;
